import { Action, ActionNames } from '../actions';
const files = (state: File[] = [],  action: Action) => {
    if (action.type === ActionNames.ReviewActions.chooseFiles) {
        return [...state, ...action.files];
    }

    if (action.type === ActionNames.ReviewActions.submitDone) {
        return [];
    }

    return state;
};

export default files;
